export const blogData = [
  {
    id: 1,
    slug: 'ikinci-el-bilgisayar-alirken-nelere-dikkat-edilmeli',
    title: '2. El Bilgisayar Alırken Nelere Dikkat Edilmeli?',
    excerpt: 'İkinci el bilgisayar alımında doğru seçim yapmak için bilmeniz gereken tüm detaylar. Güvenli alışveriş için ipuçları ve öneriler.',
    category: 'Alım Satım',
    image: 'https://public.readdy.ai/ai/img_res/8bd54aa60433f9707719def8dab623b7.jpg',
    date: '15 Ocak 2024',
    readTime: '5 dk',
    author: 'ES Bilgisayar',
  },
  {
    id: 2,
    slug: 'laptop-neden-yavaslar-cozumleri',
    title: 'Laptop Neden Yavaşlar? Nedenleri ve Çözümleri',
    excerpt: 'Laptop yavaşlama sorunlarının en yaygın nedenleri ve pratik çözüm önerileri. Bilgisayar bakım ipuçları ile performansınızı artırın.',
    category: 'Teknik Bilgi',
    image: 'https://readdy.ai/api/search-image?query=slow%20loading%20laptop%20computer%20with%20hourglass%20icon%20on%20screen%20frustrated%20user%20waiting%20modern%20office%20desk%20setup%20clean%20white%20background%20soft%20natural%20lighting%20professional%20tech%20problem%20illustration%20commercial%20quality&width=800&height=450&seq=blog2&orientation=landscape',
    date: '12 Ocak 2024',
    readTime: '6 dk',
    author: 'ES Bilgisayar',
  },
  {
    id: 3,
    slug: 'ssd-yukseltme-bilgisayari-hizlandirir-mi',
    title: 'SSD Yükseltme Bilgisayarı Hızlandırır mı?',
    excerpt: 'SSD yükseltmenin bilgisayar performansına etkileri ve RAM yükseltme ile karşılaştırması. Donanım yükseltme rehberi.',
    category: 'Donanım',
    image: 'https://readdy.ai/api/search-image?query=modern%20SSD%20solid%20state%20drive%20being%20installed%20into%20laptop%20computer%20close%20up%20technical%20view%20clean%20white%20background%20professional%20hardware%20upgrade%20scene%20bright%20studio%20lighting%20commercial%20tech%20photography&width=800&height=450&seq=blog3&orientation=landscape',
    date: '10 Ocak 2024',
    readTime: '7 dk',
    author: 'ES Bilgisayar',
  },
  {
    id: 4,
    slug: 'bilgisayar-tamiri-ne-kadar-surer',
    title: 'Bilgisayar Tamiri Ne Kadar Sürer?',
    excerpt: 'Farklı arıza türlerinde bilgisayar tamiri ve laptop tamiri süreleri. Teknik servis süreçleri hakkında bilmeniz gerekenler.',
    category: 'Servis',
    image: 'https://readdy.ai/api/search-image?query=professional%20technician%20repairing%20laptop%20computer%20on%20clean%20workbench%20with%20tools%20modern%20tech%20repair%20shop%20white%20background%20focused%20work%20scene%20bright%20lighting%20commercial%20service%20photography&width=800&height=450&seq=blog4&orientation=landscape',
    date: '8 Ocak 2024',
    readTime: '4 dk',
    author: 'ES Bilgisayar',
  },
  {
    id: 5,
    slug: 'ikinci-el-laptop-almak-mantikli-mi',
    title: 'İkinci El Laptop Almak Mantıklı mı?',
    excerpt: '2. el laptop satışı ve alımında avantajlar, dezavantajlar. Uygun fiyatlı ikinci el bilgisayar seçenekleri ve öneriler.',
    category: 'Alım Satım',
    image: 'https://readdy.ai/api/search-image?query=comparison%20scene%20showing%20new%20and%20refurbished%20laptops%20side%20by%20side%20on%20white%20surface%20price%20tags%20visible%20modern%20tech%20store%20setting%20clean%20professional%20product%20display%20bright%20studio%20lighting%20commercial%20photography&width=800&height=450&seq=blog5&orientation=landscape',
    date: '5 Ocak 2024',
    readTime: '6 dk',
    author: 'ES Bilgisayar',
  },
  {
    id: 6,
    slug: 'bilgisayar-bakiminin-onemi',
    title: 'Bilgisayar Bakımının Önemi ve Faydaları',
    excerpt: 'Düzenli bilgisayar bakım ve onarım ile cihazınızın ömrünü uzatın. Fan temizliği, format atma ve genel bakım önerileri.',
    category: 'Bakım',
    image: 'https://readdy.ai/api/search-image?query=computer%20maintenance%20cleaning%20scene%20with%20compressed%20air%20and%20cleaning%20tools%20laptop%20being%20serviced%20on%20white%20workbench%20professional%20tech%20care%20bright%20clean%20environment%20commercial%20service%20photography&width=800&height=450&seq=blog6&orientation=landscape',
    date: '3 Ocak 2024',
    readTime: '5 dk',
    author: 'ES Bilgisayar',
  },
];

export const blogPosts = blogData;